var _metadata, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUcVertRgb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 221.58667 165.02667",
    height: 165.02667,
    width: 221.58667,
    xmlSpace: "preserve",
    id: "svg2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata8"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,165.02667)",
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.1)",
    id: "g12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 15.668,367.285 v 76.094 h 28.4297 v -75.332 c 0,-21.699 10.5156,-32.91 27.8711,-32.91 17.3437,0 27.871,10.84 27.871,31.953 v 76.289 h 28.4182 v -75.137 c 0,-40.332 -21.973,-60.117 -56.6603,-60.117 -34.7071,0 -55.9297,19.961 -55.9297,59.16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 168.316,443.379 h 26.211 l 60.528,-81.992 v 81.992 h 28.054 V 310.215 H 258.93 l -62.567,84.648 v -84.648 h -28.047 v 133.164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 326.5,443.379 h 28.418 V 310.215 H 326.5 v 133.164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 387.223,443.379 h 31.367 l 33.777,-93.789 33.781,93.789 h 30.633 L 464.555,309.258 h -25.106 l -52.226,134.121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 547.809,443.379 h 97.441 v -26.055 h -69.211 v -27.031 h 60.91 v -26.055 h -60.91 V 336.27 h 70.129 v -26.055 h -98.359 v 133.164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path24",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 747.145,378.691 c 13.835,0 21.777,7.618 21.777,18.829 v 0.39 c 0,12.559 -8.496,19.024 -22.336,19.024 h -28.231 v -38.243 z m -57.219,64.688 h 59.062 c 16.418,0 29.153,-4.746 37.649,-13.516 7.195,-7.422 11.074,-17.871 11.074,-30.429 v -0.371 c 0,-21.504 -11.262,-35.02 -27.688,-41.29 l 31.563,-47.558 h -33.223 l -27.683,42.617 h -0.371 -21.954 v -42.617 h -28.429 v 133.164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path26",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 832.965,329.609 16.797,20.743 c 11.629,-9.903 23.808,-16.172 38.574,-16.172 11.629,0 18.641,4.746 18.641,12.558 v 0.371 c 0,7.422 -4.422,11.231 -26.024,16.934 -26.015,6.855 -42.812,14.277 -42.812,40.723 v 0.371 c 0,24.16 18.828,40.136 45.214,40.136 18.829,0 34.883,-6.074 47.989,-16.933 l -14.766,-22.07 c -11.445,8.183 -22.695,13.144 -33.594,13.144 -10.879,0 -16.613,-5.137 -16.613,-11.601 v -0.391 c 0,-8.75 5.539,-11.602 27.871,-17.5 26.203,-7.051 40.977,-16.738 40.977,-39.961 v -0.371 c 0,-26.445 -19.559,-41.289 -47.43,-41.289 -19.57,0 -39.316,7.051 -54.824,21.308"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 976.012,443.379 h 28.418 V 310.215 h -28.418 v 133.164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path30",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1077.91,416.367 h -39.32 v 27.012 h 107.04 v -27.012 h -39.31 V 310.215 h -28.41 v 106.152"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path32",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1218.54,362.715 -49.65,80.664 h 33.22 l 30.82,-53.457 31.38,53.457 h 32.31 l -49.65,-80.098 v -53.066 h -28.43 v 52.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1494.84,376.406 v 0.391 c 0,22.832 -16.23,41.855 -39.12,41.855 -22.89,0 -38.75,-18.652 -38.75,-41.484 v -0.371 c 0,-22.832 16.24,-41.856 39.12,-41.856 22.89,0 38.75,18.633 38.75,41.465 z m -107.6,0 v 0.391 c 0,37.851 28.99,68.867 68.85,68.867 39.86,0 68.48,-30.625 68.48,-68.496 v -0.371 c 0,-37.871 -28.99,-68.867 -68.85,-68.867 -39.86,0 -68.48,30.625 -68.48,68.476"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path36",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1556.13,443.379 h 98.36 v -26.641 h -69.94 v -28.34 h 61.64 v -26.64 h -61.64 v -51.543 h -28.42 v 133.164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path38",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 123.898,256.961 C 53.2539,256.961 0,201.719 0,128.48 v -0.73 C 0,93.0508 12.3672,60.8398 34.8242,37.1211 57.4844,13.1797 88.5078,0 122.172,0 c 39.883,0 68.016,12.5508 96.816,43.2617 l -25.879,27.1172 c -20.738,-19.8672 -39.73,-32.1601 -69.554,-32.1601 -45.4495,0 -81.0394,39.6523 -81.0394,90.2612 v 0.719 c 0,51.031 34.8438,89.531 81.0394,89.531 24.488,0 45.422,-9.468 67.758,-30.66 l 25.949,30.91 c -19.301,18.911 -45.586,37.981 -93.364,37.981"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path40",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 400.559,101.59 h -86.692 l 43.164,104.148 z M 439.785,4.28125 h 44.61 L 378.699,254.453 H 336.832 L 231.133,4.28125 h 43.129 L 299.215,64.7891 H 415.211 L 439.785,4.28125"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path42",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1108.82,101.59 h -86.7 l 43.17,104.148 z m 39.24,-97.30875 h 44.59 L 1086.95,254.453 h -41.86 L 939.41,4.28125 h 43.125 l 24.945,60.50785 h 115.99 l 24.59,-60.50785"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path44",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 510.695,4.28125 h 170.93 V 42.1719 H 554.234 V 252.656 H 510.695 V 4.28125"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path46",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 812.297,256.961 c -69.481,0 -126.453,-56.43 -126.453,-128.481 v -0.73 C 685.844,52.5313 739.617,0 812.969,0 859.449,0 892.965,20.8203 916.91,38.4219 V 142.051 h -99.512 v -36.102 h 56.543 V 57.3789 l -0.41,-0.3203 C 857.672,44.8789 836.105,37.8711 814.363,37.8711 c -49.129,0 -83.468,37.2695 -83.468,90.6089 v 0.719 c 0,49.352 35.73,89.531 79.64,89.531 30.895,0 49.52,-10.531 67.742,-26.39 l 25.645,31.582 c -27.082,23.461 -53.711,33.039 -91.625,33.039"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path48",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1327.28,128.461 h -63.42 v 86.32 h 63.07 c 32.59,0 51.27,-15.519 51.27,-42.633 v -0.726 c 0,-26.113 -20,-42.961 -50.92,-42.961 z M 1378.37,4.28125 h 47.55 l -65.07,94.41015 1.45,0.4297 c 36.78,10.8589 61.33,37.4299 61.33,74.8199 v 0.731 c 0,21.09 -11.15,39.508 -24.08,53.277 -15.98,16.172 -39.91,24.707 -69.16,24.707 H 1220.64 V 4.28125 h 43.22 V 91.6484 h 54.98 l 59.53,-87.36715"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path50",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1520.03,4.28125 h 46.47 V 99.8203 l 95.39,152.8357 h -47.99 l -69.14,-111.918 -68.46,111.918 h -48.82 L 1520.03,99.8203 V 4.28125"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path52",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 834.883,1237.67 c -196.93,0 -278.535,-66.09 -278.535,-66.09 V 875.352 c 0,-164.055 216.976,-334.258 278.535,-351.192 61.508,16.934 278.467,187.137 278.467,351.192 v 296.228 c 0,0 -81.53,66.09 -278.467,66.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path54",
    style: {
      fill: "#facb07",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 800.883,870.91 c 1.262,-1.613 2.14,-3.531 2.14,-5.719 0,-5.347 -4.414,-9.617 -9.82,-9.617 -5.476,0 -9.926,4.27 -9.926,9.617 0,2.836 1.332,5.321 3.325,7.075 -7.762,1.437 -15.848,5.386 -15.848,5.386 1.809,-5.601 5.883,-27.097 20.004,-28.629 17.445,-1.972 21.961,14.219 21.961,14.219 0,0 -2.918,5.168 -11.836,7.668"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path56",
    style: {
      fill: "#facb07",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 884.215,872.266 c 2.012,-1.754 3.328,-4.239 3.328,-7.075 0,-5.347 -4.461,-9.617 -9.93,-9.617 -5.402,0 -9.824,4.27 -9.824,9.617 0,2.188 0.887,4.106 2.149,5.719 -8.926,-2.5 -11.836,-7.668 -11.836,-7.668 0,0 4.511,-16.191 21.961,-14.219 14.113,1.532 18.195,23.028 20.011,28.629 0,0 -8.086,-3.949 -15.859,-5.386"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path58",
    style: {
      fill: "#facb07",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 900.629,922.172 c -5.711,4.723 -13.211,-1.184 -7.547,-7.59 4.727,-5.324 7.832,-8.762 5.781,-12.652 -2.793,-5.278 -29.394,-3.985 -63.453,-16.797 -34.058,12.812 -60.652,11.519 -63.457,16.797 -2.043,3.89 1.067,7.328 5.781,12.652 5.668,6.406 -1.828,12.313 -7.543,7.59 -4.8,-3.934 -13.597,-16.074 -10.445,-24.219 4.973,-12.976 35.313,-8.887 75.574,-25.57 v -0.07 c 0.032,0.015 0.063,0.027 0.09,0.035 0.031,-0.008 0.059,-0.02 0.086,-0.035 v 0.07 c 40.262,16.683 70.613,12.594 75.574,25.57 3.164,8.145 -5.644,20.285 -10.441,24.219"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path60",
    style: {
      fill: "#facb07",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 864.781,752.91 c -5.215,2.055 -14.562,7.469 -17.199,16.918 -2.363,8.629 0.988,14.551 4.875,15.508 3.672,0.883 7.617,-1.559 6.035,-6.063 -1.133,-3.378 -4.765,-5.085 -6.094,-5.945 -2.207,-1.32 -0.312,-4.246 2.481,-3.699 6.141,1.199 9.687,7.898 9.453,12.637 -0.293,7.339 -8.664,9.078 -13.262,8.187 -7.191,-1.387 -12.418,-8.523 -9.461,-20.824 2.821,-11.641 13.121,-17.926 18.524,-20.387 -4.707,-1.965 -14.903,-3.57 -24.727,-4.183 -9.832,0.613 -20.015,2.218 -24.722,4.183 5.394,2.461 15.707,8.746 18.511,20.387 2.977,12.301 -2.261,19.437 -9.437,20.824 -4.606,0.891 -12.977,-0.848 -13.27,-8.187 -0.238,-4.739 3.317,-11.438 9.446,-12.637 2.793,-0.547 4.691,2.379 2.484,3.699 -1.332,0.86 -4.961,2.567 -6.094,5.945 -1.582,4.504 2.371,6.946 6.031,6.063 3.895,-0.957 7.247,-6.879 4.883,-15.508 -2.636,-9.449 -11.988,-14.863 -17.211,-16.918 -4.445,-1.746 -5.089,-6.289 -2.304,-7.906 9.211,-5.231 22.703,-6.41 31.027,-6.52 v -0.019 c 0.199,0 0.449,0.012 0.656,0.015 0.215,-0.003 0.461,-0.015 0.668,-0.015 v 0.019 c 8.321,0.11 21.813,1.289 31.031,6.52 2.774,1.617 2.129,6.16 -2.324,7.906"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path62",
    style: {
      fill: "#facb07",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 835.602,1143.88 c 2.464,0.35 5.273,1.11 7.664,2.75 v 0 c 0.367,0.33 0.703,0.58 1.074,0.87 2.648,2.45 7.98,9.8 9.562,13.03 0.352,0.58 0.352,1.24 0,2.05 -0.703,1.64 -2.472,3.18 -2.968,3.31 -2.383,0.82 -28.391,0.89 -30.844,0.06 v 0 c 0,0 -0.133,-0.03 -0.426,-0.19 -1.164,-0.84 -3.418,-3.26 -2.617,-5.04 1.523,-3.08 7.207,-10.71 9.879,-13.16 2.508,-2.25 5.785,-3.15 8.676,-3.68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path64",
    style: {
      fill: "#facb07",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 815.664,1131.45 c 0.289,2.36 0.406,5.19 -0.398,7.85 v 0 c -0.106,0.44 -0.282,0.81 -0.5,1.29 -1.602,3.18 -7.286,10.12 -9.922,12.59 -0.543,0.5 -1.231,0.68 -2.039,0.65 -1.864,-0.15 -3.887,-1.34 -4.239,-1.74 -1.515,-1.95 -9.628,-25.78 -9.589,-28.22 v 0 c 0,0 0,-0.17 0.132,-0.49 0.418,-1.33 2.075,-4.16 4.176,-3.89 3.438,0.37 12.848,3.38 16.047,5.11 2.969,1.56 4.883,4.31 6.332,6.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path66",
    style: {
      fill: "#facb07",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 821.68,1109.29 c -2.27,1.03 -4.946,2.08 -7.789,2.08 v 0 c -0.493,0 -0.938,0 -1.395,-0.09 -3.695,-0.46 -12.387,-3.69 -15.672,-5.44 -0.594,-0.31 -1,-0.85 -1.211,-1.64 -0.453,-1.72 0.071,-3.92 0.332,-4.39 1.535,-2.01 22.469,-16.77 24.946,-17.56 v 0 c 0,0 0.066,0 0.472,0 1.418,0 4.828,0.68 5.231,2.64 0.617,3.26 0.617,12.96 -0.094,16.46 -0.602,3.22 -2.762,5.8 -4.82,7.94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path68",
    style: {
      fill: "#facb07",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 845.492,1108.02 c -1.754,-1.73 -3.633,-3.89 -4.519,-6.59 v 0 c -0.168,-0.43 -0.246,-0.86 -0.332,-1.33 -0.707,-3.48 -0.239,-12.58 0.359,-16.13 0.188,-0.64 0.602,-1.19 1.27,-1.69 1.636,-0.95 3.945,-1.06 4.449,-0.98 2.535,0.72 23.531,15.38 25.015,17.48 v 0 c 0,0 0.118,0.05 0.157,0.34 0.527,1.36 0.879,4.66 -0.938,5.58 -3.039,1.67 -12.539,4.74 -16.164,5.25 -3.426,0.44 -6.601,-0.72 -9.297,-1.93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path70",
    style: {
      fill: "#facb07",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 854.059,1129.36 c 1.23,-2.13 2.734,-4.47 5.097,-6.13 v 0 c 0.313,-0.21 0.711,-0.48 1.199,-0.69 3.235,-1.7 12.317,-4.32 15.969,-4.81 0.684,-0.15 1.309,0.11 2.012,0.67 1.473,1.12 2.352,3.2 2.402,3.71 0.039,2.49 -7.929,26.28 -9.445,28.31 v 0 c 0,0 -0.098,0.14 -0.359,0.29 -1.192,0.88 -4.368,2.2 -5.782,0.84 -2.578,-2.28 -8.554,-9.86 -10.109,-13.07 -1.523,-2.93 -1.336,-6.25 -0.984,-9.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path72",
    style: {
      fill: "#facb07",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 841.848,1121.74 c -1.535,0.39 -2.375,2.02 -1.914,3.5 0.554,1.46 2.156,2.28 3.656,1.75 1.488,-0.46 2.351,-2.02 1.84,-3.45 -0.457,-1.49 -2.094,-2.23 -3.582,-1.8 z m -6.012,8.58 c -1.328,0.87 -1.613,2.63 -0.645,3.89 0.883,1.27 2.668,1.51 4.024,0.64 1.273,-0.95 1.508,-2.71 0.566,-3.9 -0.902,-1.25 -2.718,-1.56 -3.945,-0.63 z m 0.34,-16.03 c -1.582,0 -2.84,1.22 -2.84,2.78 0,1.52 1.258,2.79 2.84,2.79 1.621,0 2.918,-1.27 2.918,-2.79 0,-1.56 -1.297,-2.78 -2.918,-2.78 z m -6.684,13.75 c -1.347,-0.93 -3.144,-0.58 -4.043,0.66 -0.965,1.27 -0.66,2.98 0.59,3.87 1.34,0.93 3.066,0.61 4.031,-0.63 0.977,-1.23 0.676,-2.96 -0.578,-3.9 z m -1.59,-9.93 c -1.554,-0.47 -3.175,0.31 -3.648,1.75 -0.441,1.45 0.324,3.01 1.785,3.52 1.613,0.47 3.242,-0.29 3.641,-1.75 0.55,-1.51 -0.278,-3.04 -1.778,-3.52 z m 22.036,9.35 c -0.645,1.23 -1.7,2.2 -2.891,3 0.156,0.88 0.254,1.78 0.078,2.68 -0.34,2.21 -1.527,4.07 -3.379,5.47 -3.078,2.12 -7.308,1.82 -10.273,-0.32 -2.852,1.35 -6.43,1.31 -9.063,-0.53 -1.816,-1.3 -3.09,-3.2 -3.363,-5.43 -0.293,-1.4 -0.039,-2.74 0.43,-4.02 -0.664,-0.62 -1.297,-1.28 -1.727,-2.1 -1.051,-2.01 -1.203,-4.24 -0.504,-6.35 1.137,-3.49 4.484,-5.77 8.195,-5.77 0.086,0 0.168,0.04 0.254,0.04 1.414,-2.7 4.219,-4.6 7.621,-4.6 3.883,0 7.086,2.56 8.168,5.99 3.219,0.46 5.946,2.53 6.961,5.58 0.762,2.13 0.528,4.33 -0.507,6.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path74",
    style: {
      fill: "#facb07",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 681.293,1157.15 c -8.02,7.51 -12.523,9.19 -14.855,9.19 -1.321,0 -2.969,-0.45 -5.719,-3.39 -0.692,-0.69 -1.383,-1.49 -2.059,-2.23 -3.816,-4.38 -8.539,-9.93 -16.82,-9.93 -3.067,0 -6.317,0.85 -9.824,2.49 v -63.32 c 3.211,-5.51 6.418,-8.66 9.136,-8.66 1.504,0 4.086,0.86 8.063,5.15 9.344,9.96 20.621,11.82 32.078,5.07 v 65.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path76",
    style: {
      fill: "#facb07",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 731.652,1150.79 c -8.246,0 -13.047,5.55 -16.808,9.93 -0.684,0.74 -1.383,1.54 -2.051,2.23 -2.73,2.94 -4.414,3.39 -5.738,3.39 -2.367,0 -6.825,-1.68 -14.809,-9.19 v -65.63 c 4.469,2.67 8.938,3.99 13.395,3.99 6.738,0 12.964,-3.03 18.675,-9.06 3.926,-4.29 6.528,-5.15 8,-5.15 2.782,0 5.961,3.15 9.145,8.66 v 63.32 c -3.5,-1.64 -6.766,-2.49 -9.809,-2.49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path78",
    style: {
      fill: "#facb07",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 988.863,1091.52 c 11.467,6.75 22.737,4.89 32.077,-5.07 3.98,-4.29 6.56,-5.15 8.06,-5.15 2.72,0 5.94,3.15 9.14,8.66 v 63.32 c -3.51,-1.64 -6.76,-2.49 -9.82,-2.49 -8.29,0 -13.01,5.55 -16.82,9.93 -0.68,0.74 -1.37,1.54 -2.06,2.23 -2.75,2.94 -4.41,3.39 -5.71,3.39 -2.35,0 -6.839,-1.68 -14.867,-9.19 v -65.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path80",
    style: {
      fill: "#facb07",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 938.512,1150.79 c -3.047,0 -6.309,0.85 -9.817,2.49 v -63.32 c 3.184,-5.51 6.36,-8.66 9.153,-8.66 1.465,0 4.062,0.86 7.988,5.15 5.723,6.03 11.941,9.06 18.68,9.06 4.464,0 8.925,-1.32 13.39,-3.99 v 65.63 c -7.98,7.51 -12.441,9.19 -14.804,9.19 -1.329,0 -3.008,-0.45 -5.743,-3.39 -0.664,-0.69 -1.367,-1.49 -2.05,-2.23 -3.75,-4.38 -8.555,-9.93 -16.797,-9.93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path82",
    style: {
      fill: "#facb07",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 770.129,958.035 c -20.41,7.106 -62.098,27.711 -79.734,76.785 -4.555,12.67 -11.215,10.8 -9.961,-2.68 3.281,-35.316 25.679,-78.265 72.656,-97.785 20.144,-8.343 31.445,18.668 17.039,23.68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path84",
    style: {
      fill: "#facb07",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 900.699,958.035 c 20.41,7.106 62.09,27.711 79.727,76.785 4.551,12.67 11.211,10.8 9.961,-2.68 -3.282,-35.316 -25.684,-78.265 -72.657,-97.785 -20.136,-8.343 -31.445,18.668 -17.031,23.68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path86",
    style: {
      fill: "#facb07",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 887.945,967.973 c 2.774,0.59 6.746,1.644 11.309,3.129 12.598,4.757 35,16.097 52.187,38.798 -39.543,7.72 -79.824,11.9 -115.878,11.9 -36.36,0 -76.895,-4.27 -116.672,-12.12 17.933,-23.559 41.48,-34.832 53.652,-39.176 3.828,-1.137 7.266,-2.02 9.668,-2.531 5.66,-1.2 11.406,-2.114 18.484,3.781 7.086,5.93 8.383,9.461 34.383,9.461 26,0 27.301,-3.531 34.391,-9.461 7.07,-5.895 12.812,-4.981 18.476,-3.781"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path88",
    style: {
      fill: "#facb07",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1023.53,904.59 -58.065,-95.82 c 21.894,9.906 54.665,34.828 58.065,95.82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path90",
    style: {
      fill: "#facb07",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 704.691,808.77 -58.07,95.82 c 3.402,-60.992 36.172,-85.914 58.07,-95.82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path92",
    style: {
      fill: "#facb07",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 1008.37,735.152 C 997.203,726.188 988.492,720.02 981.48,715.094 966.129,704.34 960.211,699.48 960.875,691.469 l 2.695,-34.489 -20.136,9.329 c -15.891,7.046 -23.301,16.605 -24.688,32.023 -2.16,23.883 12.617,48.75 39.492,66.633 6.375,4.183 12.071,7.195 16.66,9.476 4.532,2.313 8.731,4.774 9.122,5.977 0.878,2.656 -4.18,6.992 -18.965,13.594 -1.504,0.672 -4.258,1.836 -6.778,2.894 L 835.078,593.633 711.879,796.906 c -2.52,-1.058 -5.277,-2.222 -6.777,-2.894 -14.786,-6.602 -19.844,-10.938 -18.969,-13.594 0.394,-1.203 4.601,-3.664 9.133,-5.977 4.589,-2.281 10.277,-5.293 16.66,-9.476 26.875,-17.883 41.644,-42.75 39.48,-66.633 -1.386,-15.418 -8.793,-24.977 -24.676,-32.023 l -20.136,-9.329 2.687,34.489 c 0.664,8.011 -5.254,12.871 -20.597,23.625 -7.02,4.926 -15.731,11.094 -26.907,20.058 -68.961,55.414 -71.211,125.239 -51.043,154.981 6.715,9.793 25.657,31.015 25.774,31.14 l -3.184,4.903 c -6.933,0.676 -12.379,6.449 -12.379,13.562 0,7.567 6.133,13.7 13.7,13.7 7.562,0 13.695,-6.133 13.695,-13.7 0,-1.468 -0.293,-2.855 -0.719,-4.183 0.129,-0.102 0.328,-0.145 0.262,-0.422 L 835.078,621.789 1022.28,935.133 c -0.08,0.277 0.13,0.32 0.25,0.422 -0.43,1.328 -0.72,2.715 -0.72,4.183 0,7.567 6.13,13.7 13.7,13.7 7.57,0 13.7,-6.133 13.7,-13.7 0,-7.113 -5.45,-12.886 -12.38,-13.562 l -3.18,-4.903 c 0.11,-0.125 19.06,-21.347 25.78,-31.14 20.16,-29.742 17.91,-99.567 -51.06,-154.981 z m -12.155,264.34 c -7.977,-21.875 -22.527,-44.543 -45.449,-61.601 18.222,-5.77 41.144,-5.903 56.804,4.496 -5.33,-13.617 -21.98,-31.348 -34.031,-43.02 -2.187,1.457 -4.375,3.363 -5.965,5.055 -4.844,5.176 -9.219,0.625 -5.918,-3.664 1.153,-1.485 4.102,-5.695 5.84,-7.121 -3.594,-3.324 -6.211,-5.625 -6.992,-6.313 -2.434,1.481 -4.934,3.711 -6.699,5.594 -4.844,5.176 -9.219,0.625 -5.918,-3.664 1.172,-1.52 4.246,-5.926 5.957,-7.254 -2.961,-2.371 -6.211,-4.949 -9.094,-6.914 -6.062,7.656 -12.566,15.68 -22.391,10.66 -10.39,-5.312 -0.078,-12.301 -0.078,-22.707 0,-41.551 -26.133,-56.976 -32.59,-74.59 -6.531,-17.59 -12.664,-49.047 -17.832,-57.64 -5.078,-8.457 -26.808,-17.946 -36.781,-10.114 -9.969,-7.832 -31.902,1.539 -36.781,10.114 -4.891,8.593 -11.817,40.05 -18.348,57.64 -6.457,17.614 -32.078,33.039 -32.078,74.59 0,10.406 10.313,17.395 -0.078,22.707 -9.813,5.02 -16.316,-3.004 -22.387,-10.66 -2.883,1.965 -6.133,4.543 -9.097,6.914 1.714,1.328 4.796,5.734 5.961,7.254 3.3,4.289 -1.075,8.84 -5.918,3.664 -1.766,-1.883 -4.266,-4.113 -6.696,-5.594 -0.785,0.688 -3.402,2.989 -6.988,6.313 1.73,1.426 4.687,5.636 5.828,7.121 3.301,4.289 -1.074,8.84 -5.918,3.664 -1.586,-1.692 -3.773,-3.598 -5.961,-5.055 -12.051,11.672 -28.703,29.403 -34.035,43.02 16.301,-10.821 37.457,-10.297 55.969,-3.828 -22.317,16.89 -36.582,39.101 -44.481,60.589 -35.277,-9.714 -68.343,-22.32 -95.269,-37.574 v -88.5 c 0,-142.879 204.281,-308.054 256.73,-322.82 52.434,14.766 255.379,179.941 255.379,322.82 v 89.356 c -26.73,15.054 -59.61,27.48 -94.695,37.062"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path94",
    style: {
      fill: "#d81e25",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1053.57,1063.25 -61.066,12.96 v -5.7 h -18.211 v 5.7 l -33.926,-5.09 c -0.422,-0.08 -0.84,-0.16 -1.25,-0.19 l -25.84,-3.88 v 90.09 l 4.551,1.27 v 14.99 l 8.75,-6.46 c 6.192,-4.65 9.902,-5.64 11.914,-5.64 2.996,0 5.156,2.32 8.477,6.16 0.801,0.84 1.551,1.72 2.285,2.56 4.316,4.55 8.769,6.77 13.836,6.77 5.988,0 12.453,-3.36 20.344,-10.3 7.851,6.94 14.316,10.3 20.276,10.3 5.05,0 9.52,-2.22 13.79,-6.77 0.78,-0.84 1.55,-1.72 2.3,-2.56 3.28,-3.84 5.54,-6.16 8.51,-6.16 1.99,0 5.69,0.99 11.87,5.64 l 8.81,6.46 v -14.99 l 4.58,-1.27 z m -160.019,43.55 c -0.899,-2.67 -4.434,-4.11 -8.867,-4.16 0.046,-2.54 -0.625,-5.02 -1.321,-6.02 -2.508,-3.33 -31.16,-23.26 -35.203,-24.5 -0.449,-0.11 -0.996,-0.14 -1.637,-0.14 -1.308,0 -2.738,0.2 -4.265,0.61 -1.324,-4.37 -3.961,-7.43 -7,-7.43 -2.942,0 -5.551,2.89 -6.906,7.13 -1.727,-0.64 -3.594,-0.95 -5.055,-0.95 -0.723,0 -1.262,0.05 -1.774,0.16 -4.007,1.28 -32.535,21.38 -34.945,24.77 -0.711,0.92 -1.297,3.03 -1.426,5.29 -4.504,0 -8.105,1.4 -9,4.12 -0.879,2.73 1.059,5.92 4.692,8.49 -1.934,2.14 -3.074,5.03 -3.074,6.27 -0.075,4.13 10.886,36.47 13.539,39.76 0.683,0.81 2.691,2.17 5.144,2.98 -1.258,4.01 -0.89,7.58 1.434,9.23 2.285,1.57 5.879,0.93 9.285,-1.41 1.562,2.4 3.957,4.31 5.215,4.72 2.652,0.87 14.492,0.95 19.511,0.95 7.715,0 21.418,-0.26 23.965,-1.06 1.223,-0.43 3.262,-2.09 4.766,-4.19 3.703,2.51 7.383,3.34 9.785,1.65 2.238,-1.54 2.727,-5.02 1.563,-8.85 2.726,-0.74 5.011,-2.3 5.675,-3.23 2.598,-3.26 13.387,-35.67 13.301,-39.85 0,-1.17 -0.918,-3.56 -2.531,-5.63 3.859,-2.62 6.086,-5.87 5.129,-8.71 z m -136.664,-39.75 -25.848,3.88 c -0.414,0.03 -0.828,0.11 -1.242,0.19 l -33.93,5.09 v -5.7 h -9.094 -9.121 v 5.7 l -61.058,-12.96 v 93.89 l 4.574,1.27 v 14.99 l 8.809,-6.46 c 6.179,-4.65 9.882,-5.64 11.875,-5.64 2.968,0 5.218,2.32 8.507,6.16 0.75,0.84 1.528,1.72 2.309,2.56 4.262,4.55 8.73,6.77 13.777,6.77 5.957,0 12.426,-3.36 20.285,-10.3 7.879,6.94 14.356,10.3 20.336,10.3 5.067,0 9.528,-2.22 13.84,-6.77 0.731,-0.84 1.489,-1.72 2.282,-2.56 3.32,-3.84 5.48,-6.16 8.472,-6.16 2.012,0 5.727,0.99 11.926,5.64 l 8.742,6.46 v -14.99 l 4.559,-1.27 z m 77.953,149.37 c -189.078,0 -256.039,-57.86 -256.039,-57.86 V 988.371 c 25.625,13.129 56.453,24.049 89.269,32.669 -0.609,3.36 -1.117,6.67 -1.41,9.85 -0.847,9.12 0.863,16.09 5.086,20.73 3.082,3.38 7.242,5.24 11.715,5.24 4.863,0 13.844,-2.27 19.309,-17.48 1.21,-3.36 2.578,-6.54 4.015,-9.61 43.746,8.73 88.16,13.44 128.055,13.44 39.805,0 84.863,-4.69 128.555,-13.41 1.425,3.07 2.793,6.23 3.992,9.58 5.461,15.21 14.445,17.48 19.308,17.48 4.473,0 8.633,-1.86 11.719,-5.24 4.216,-4.64 5.936,-11.61 5.076,-20.73 -0.29,-3.21 -0.81,-6.57 -1.42,-9.97 32.64,-8.59 63.32,-19.49 88.84,-32.549 v 170.189 c 0,0 -67.08,57.86 -256.07,57.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path96",
    style: {
      fill: "#d81e25",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 981.508,801.039 c 8.469,-4.613 17.199,-11.402 17.199,-20.621 0,-9.813 -8.203,-13.996 -16.965,-18.484 -4.48,-2.317 -9.492,-4.829 -15.164,-8.657 -8.457,-5.597 -35.695,-25.945 -33.223,-53.707 0.918,-9.664 4.532,-14.804 14.149,-19.488 l -1.258,12.477 c -0.566,12.39 10.516,22.695 26.57,33.972 6.848,4.844 15.344,10.828 26.184,19.492 59.43,47.735 66.07,109.832 48.14,136.348 -2.4,3.524 -5.91,8.551 -9.49,13.512 -5.31,-54.117 -32.87,-81.317 -56.142,-94.844"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path98",
    style: {
      fill: "#d81e25",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 632.5,895.883 c -3.57,-4.961 -7.09,-9.988 -9.488,-13.512 -17.934,-26.516 -11.282,-88.613 48.144,-136.348 10.848,-8.664 19.336,-14.648 26.184,-19.492 16.055,-11.277 27.137,-21.582 26.566,-33.972 l -1.254,-12.477 c 9.618,4.684 13.239,9.824 14.145,19.488 2.476,27.762 -24.754,48.11 -33.211,53.707 -5.68,3.828 -10.695,6.34 -15.172,8.657 -8.766,4.488 -16.969,8.671 -16.969,18.484 0,9.219 8.743,16.008 17.203,20.621 -23.277,13.527 -50.835,40.727 -56.148,94.844"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUcVertRgb);
export default __webpack_public_path__ + "static/media/UC-vert-rgb.178ed5453b2a510c6e2c1ea6774d3db5.svg";
export { ForwardRef as ReactComponent };